export enum SIC_PackageType {
PublicSector,
PrivateSector,
TEKA,
}
